/**
 * Relative times in Moment's friendly phrasing ("a few seconds ago", "a day
 * ago"), built on date-fns so code can move off Moment.
 *
 * date-fns' own wording is either hedged ("about 1 hour ago") or exact ("10
 * seconds ago"). This keeps its strict, rounded distances and only changes
 * the words.
 */

import { formatDistanceStrict } from 'date-fns';
import { enUS } from 'date-fns/locale';

const UNITS = {
  xMinutes: 'minute',
  xHours: 'hour',
  xDays: 'day',
  xMonths: 'month',
  xYears: 'year',
};

// Moment calls anything under 45 seconds "a few seconds"
const FEW_SECONDS = 45;

function words(token, count) {
  if (token === 'xSeconds') {
    return count < FEW_SECONDS ? 'a few seconds' : 'a minute';
  }

  const unit = UNITS[token];

  if (count === 1) {
    return unit === 'hour' ? 'an hour' : `a ${unit}`;
  }

  return `${count} ${unit}s`;
}

const locale = {
  ...enUS,
  formatDistance(token, count, options) {
    const distance = words(token, count);

    if (!options?.addSuffix) {
      return distance;
    }

    return options.comparison > 0 ? `in ${distance}` : `${distance} ago`;
  },
};

/** How long ago `date` was, e.g. "a day ago" or "3 hours ago". */
export function timeAgo(date, now = new Date()) {
  return formatDistanceStrict(new Date(date), now, {
    addSuffix: true,
    locale,
  });
}

export default timeAgo;
